'use client';
import clsx from 'clsx';
import { Button } from '../../../Button';
import { useDropdownContext } from '../../../DropdownProvider';
import { CaretDown } from '../../../Icons/CaretDown';
import { CaretUp } from '../../../Icons/CaretUp';
import {
  AUTH_BUTTONS_ROOT_URL,
  AUTH_BUTTONS_WIDTH_DESKTOP_CLASSNAME,
  AUTH_BUTTONS_WIDTH_MOBILE_CLASSNAME,
} from '../constants';
import { useMyNerdWalletHoverEventCallbacks } from './hooks';

export function MyNerdWalletButtonDesktop() {
  const {
    state: {
      myNerdWalletMenu: { isOpen },
    },
  } = useDropdownContext();
  const { handleOpenMenu, handleCloseMenu } = useMyNerdWalletHoverEventCallbacks();

  return (
    <div
      className={clsx(
        AUTH_BUTTONS_WIDTH_MOBILE_CLASSNAME,
        AUTH_BUTTONS_WIDTH_DESKTOP_CLASSNAME,
        'hidden',
        'sm:flex',
      )}
      onMouseEnter={() => handleOpenMenu('desktop')}
      onMouseLeave={handleCloseMenu}
    >
      <Button
        className={clsx('w-full', 'flex', 'items-center', 'justify-center', 'gap-2')}
        aria-expanded={isOpen}
        aria-haspopup="true"
        aria-controls="satellite-my-nerdwallet-dropdown"
        variant="secondary"
        component="a"
        href={`${AUTH_BUTTONS_ROOT_URL}/home/dashboard/home`}
        icon={
          <span
            className={clsx(
              'rounded-full',
              'w-4',
              'h-4',
              'flex',
              'items-center',
              'justify-center',
              {
                'bg-green-default': isOpen,
                'text-white': isOpen,
                'text-black': !isOpen,
                'bg-transparent': !isOpen,
              },
            )}
          >
            {isOpen ? (
              <CaretDown className={clsx('w-[12px]', 'h-[12px]')} />
            ) : (
              <CaretUp className={clsx('w-[12px]', 'h-[12px]')} />
            )}
          </span>
        }
      >
        My NerdWallet
      </Button>
    </div>
  );
}
